import { ReactiveVar, makeVar } from '@apollo/client'

import { ITemplate, ILabelCountryCodes, ITag } from 'shared/interfaces'
import { Label } from 'shared/__gql-types'

export const LabelsStore = {
  templates: {
    read: () => templatesVar()
  },
  countryList: {
    read: () => countryCodeListVar()
  },
  currentLabel: {
    read: () => currentLabelVar()
  },
  tags: {
    read: () => tagsVar()
  },
  labelTags: {
    read: () => labelTagsVar()
  }
}

export const templatesVar: ReactiveVar<ITemplate[]> = makeVar<ITemplate[]>([])
export const countryCodeListVar: ReactiveVar<ILabelCountryCodes[]> = makeVar<ILabelCountryCodes[]>([])
export const currentLabelVar: ReactiveVar<Label | null> = makeVar<Label | null>(null)
/**
 * @deprecated please use useTags instead
 */
export const labelTagsVar: ReactiveVar<ITag[]> = makeVar<ITag[]>([])
/**
 * @deprecated please use useTags instead
 */
export const tagsVar: ReactiveVar<ITag[]> = makeVar<ITag[]>([])
